module.exports = __webpack_public_path__ + "img/bkl8.c328ab6b.jpg";